import { createAction, props } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import { IGetDirectorsResponse } from '../models/get-directors.model';

export const loadGetDirectors = createAction(
  '[GetDirectors] Load GetDirectors',
  props<{ request: { businessId: string; userRoleIds: string[] } }>()
);

export const loadGetDirectorsSuccess = createAction(
  '[GetDirectors] Load GetDirectors Success',
  props<{ response: IGetDirectorsResponse[] }>()
);

export const loadGetDirectorsFailure = createAction(
  '[GetDirectors] Load GetDirectors Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);

export const clearGetDirectorsSuccess = createAction('[GetDirectors] Clear GetDirectors Success');
